module.exports = __webpack_public_path__ + "img/PDTutorial.3a198cca.png";